import { useSelector } from 'react-redux';
import { selectBrandName } from 'core/selectors/app';
import { selectUserIsIdentified } from 'core/selectors/user';

export const useCheckIsCardHolder = () => {
  const userIsIdentified = useSelector(selectUserIsIdentified);
  const brandName = useSelector(selectBrandName);

  return userIsIdentified && brandName === 'united_cardholder';
};
